<template>
  <b-row @mouseover="mouseOn()" @mouseleave="mouseOff()" class="pt-2 pb-2">
    <b-col cols="3">
      <b-row>
        <b-col cols="3">QR</b-col>
        <b-col>
          <p>
            #numer<br>
            Imię Nazwisko
          </p>
        </b-col>
      </b-row>
    </b-col>
    <b-col>
      <p>
        Statusy
      </p>
    </b-col>
    <b-col>
      <p>
        <b>15</b> zgłoszeń<br>
        <b>24,6 km</b> trasy na dziś<br>
        w pracy od <b>7:45</b><br>
        zakończenie <b>18:54</b>
      </p>
    </b-col>
    <b-col>
      <p v-if="hover === 0">
        Mercedes Sprinter #WI 12345
      </p>
      <div v-else-if="hover === 1">
        <b-row>
          <b-col>
            <b-btn class="btn-outline-primary float-right mt-1 mb-1">{{ $t('views.technicians.index.showProfile') }}</b-btn>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-btn class="btn-outline-primary float-right  mt-1 mb-1">{{ $t('views.technicians.index.showOrEditPlan') }}</b-btn>
          </b-col>
        </b-row>
        <!--        <router-link :to="{name: 'TechnicianProfile', params: { id: item['@id'] }}">-->
        <!--          <b-btn class="btn-outline-primary float-left">{{ $t('views.technicians.index.showProfile') }}</b-btn>-->
        <!--        </router-link>-->
        <!--        <router-link :to="{name: 'Technician', params: { id: item['@id'] }}">-->
        <!--          <b-btn class="btn-outline-primary float-left">{{ $t('views.technicians.index.showOrEditPlan') }}</b-btn>-->
        <!--        </router-link>-->
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'TechnicianRow',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      hover: 1
    }
  },
  methods: {
    mouseOn () {
      this.hover = 1
    },
    mouseOff () {
      this.hover = 1
    }
  }
}
</script>
